import { useEffect, useRef, useState } from 'react';
import './Header.scss';

const bgText = "//#$%@'=))))[[//'''='-\"'~^;.<>{{{}}";

function debounce(fn, delay) {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => fn(...args), delay);
  };
}

const Header = () => {
  const [repeatCount, setRepeatCount] = useState(() => {
    if (typeof window === 'undefined') return 1;
    return 1;
  });
  const spanRef = useRef(null);
  const measureRef = useRef(null);

  useEffect(() => {
    if (!measureRef.current) {
      const temp = document.createElement('span');
      temp.style.visibility = 'hidden';
      temp.style.position = 'absolute';
      temp.style.whiteSpace = 'nowrap';
      document.body.appendChild(temp);
      measureRef.current = temp;
    }
    function updateRepeat() {
      if (!spanRef.current || !measureRef.current) return;
      const vw = window.innerWidth;
      const style = window.getComputedStyle(spanRef.current);
      measureRef.current.style.fontFamily = style.fontFamily;
      measureRef.current.style.fontSize = style.fontSize;
      measureRef.current.innerText = bgText;
      const textWidth = measureRef.current.offsetWidth;
      let count = Math.ceil(vw / textWidth) + 1;
      if (!Number.isFinite(count) || count < 1) count = 1;
      setRepeatCount(count);
    }
    const debouncedUpdate = debounce(updateRepeat, 100);
    updateRepeat();
    window.addEventListener('resize', debouncedUpdate);
    return () => {
      window.removeEventListener('resize', debouncedUpdate);
      if (measureRef.current) {
        document.body.removeChild(measureRef.current);
        measureRef.current = null;
      }
    };
  }, []);

  return (
    <header className="header">
      <div className="header-bg-text">
        <span ref={spanRef}>{Array(repeatCount).fill(bgText).join('')}</span>
      </div>
      <div className="header-content">
        <h1>
          Inclusão digital<br />
          a qualquer pessoa.
        </h1>
        <p className="header-subtitle">
          Somos uma organização sem fins lucrativos que acredita no poder da tecnologia para mudar vidas. Nosso propósito é garantir que qualquer pessoa tenha acesso ao conhecimento e às oportunidades que a inclusão digital pode oferecer.
        </p>
        <a href="#projetos" className="header-btn">CONHEÇA NOSSOS PROJETOS</a>
        {/* <button className="header-btn">CONHEÇA NOSSOS PROJETOS</button> */}
      </div>
    </header>
  );
};

export default Header;
